// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout alinhado ao protótipo definicao/esocial-imposto.txt */

.styles_page__6QxgI {
  background: #fff;
  margin: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 28px 32px 32px;
  box-sizing: border-box;
}

.styles_pageHeader__B6L7O {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.styles_pageTitle__ZSo1b {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: 26px;
  font-weight: 700;
  color: #0d2847;
  margin: 0;
}

.styles_pageTitleIcon__9TKKK {
  font-size: 28px !important;
  color: #0d2847;
}

.styles_pageSubtitle__tOToz {
  margin: 6px 0 0;
  font-size: 14px;
  color: #666;
  font-weight: 400;
  max-width: 640px;
}

.styles_btnPrimary__wKjwT {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1e4a7a;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.styles_btnPrimary__wKjwT:hover {
  background: #163a62;
}

.styles_btnPrimary__wKjwT:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.styles_btnSecondary__Uk77F {
  padding: 10px 18px;
  border-radius: 6px;
  border: 1px solid #cfd8dc;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  color: #333;
}

.styles_btnSecondary__Uk77F:hover {
  background: #f5f5f5;
}

.styles_btnFilter__WO0Vb {
  padding: 10px 18px;
  border-radius: 6px;
  border: 1px solid #cfd8dc;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  color: #444;
  height: 42px;
}

.styles_btnFilter__WO0Vb:hover {
  background: #f0f2f5;
}

.styles_filtersPanel__Kkjyn {
  border: 1px solid #e8eef3;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 22px;
  background: #fafbfc;
}

.styles_filtersTitle__gHv9X {
  font-size: 13px;
  font-weight: 700;
  color: #0d2847;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 14px;
}

.styles_filtersGrid__Y-wu- {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto;
  gap: 16px 20px;
  align-items: end;
}

@media (max-width: 960px) {
  .styles_filtersGrid__Y-wu- {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 560px) {
  .styles_filtersGrid__Y-wu- {
    grid-template-columns: 1fr;
  }
}

.styles_formField__qZh8f label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #0d2847;
  margin-bottom: 6px;
}

.styles_formField__qZh8f input,
.styles_formField__qZh8f select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  box-sizing: border-box;
}

.styles_formField__qZh8f input:focus,
.styles_formField__qZh8f select:focus {
  outline: none;
  border-color: #1e4a7a;
  box-shadow: 0 0 0 2px rgba(30, 74, 122, 0.15);
}

.styles_formField__qZh8f input:disabled {
  background: #f5f5f5;
  color: #666;
}

.styles_refRange__rB5yr {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 8px;
  align-items: center;
}

.styles_refRange__rB5yr span {
  font-size: 12px;
  color: #888;
  text-align: center;
}

.styles_empresaSearchWrap__olTUb {
  position: relative;
}

.styles_empresaSugestoes__XkmOq {
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 4px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: 220px;
  overflow-y: auto;
  z-index: 50;
}

.styles_empresaSugestoesVisible__8eCEY {
  display: block;
}

.styles_empresaSugestaoItem__C3HbU {
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}

.styles_empresaSugestaoItem__C3HbU:hover {
  background: #f5f8fb;
}

.styles_empresaSugestaoNome__0V\\+aR {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.styles_empresaSugestaoCnpj__uNrPw {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}

.styles_listHint__Ys3jC {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
}

.styles_tableWrap__\\+Nr8J {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.styles_table__B59CT {
  width: 100%;
  border-collapse: collapse;
  min-width: 1100px;
}

.styles_table__B59CT thead {
  background: #f8f9fa;
}

.styles_table__B59CT th {
  padding: 12px 14px;
  text-align: left;
  font-weight: 600;
  color: #333;
  font-size: 13px;
  border-bottom: 1px solid #e8e8e8;
  white-space: nowrap;
}

.styles_table__B59CT td {
  padding: 12px 14px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #444;
}

.styles_num__Uvn9X {
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.styles_table__B59CT th.styles_num__Uvn9X,
.styles_table__B59CT td.styles_num__Uvn9X {
  text-align: center;
}

.styles_table__B59CT tbody tr:hover {
  background: #fafbfc;
}

.styles_badgeCprb__n342Z {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.styles_badgeSim__tjrqB {
  background: #e8f5e9;
  color: #2e7d32;
}

.styles_badgeNao__CL6XC {
  background: #f5f5f5;
  color: #616161;
}

.styles_acoesCell__2WxJA {
  display: flex;
  gap: 6px;
  white-space: nowrap;
}

.styles_btnIcon__RJJIf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  color: #1e4a7a;
}

.styles_btnIcon__RJJIf:hover {
  background: #eef2f7;
}

.styles_btnIconDanger__BvCAG {
  color: #c62828;
}

.styles_btnIconDanger__BvCAG:hover {
  background: #ffebee;
}

.styles_emptyMsg__9vfvw {
  text-align: center;
  padding: 32px 16px;
  color: #888;
  font-size: 14px;
}

.styles_loadingMsg__uA5Ym {
  text-align: center;
  padding: 32px 16px;
  color: #666;
  font-size: 14px;
}

.styles_modalHint__-Ile4 {
  font-size: 12px;
  color: #888;
  margin-top: 6px;
}

.styles_empresaSelecionada__7jhrR {
  margin-top: 10px;
  padding: 10px 12px;
  background: #e3f2fd;
  border-radius: 6px;
  font-size: 13px;
}

.styles_empresaSelecionada__7jhrR strong {
  display: block;
  color: #0d2847;
}

.styles_empresaSelecionada__7jhrR span {
  color: #555;
  font-size: 12px;
}

.styles_formError__CNZgY {
  font-size: 12px;
  color: #c62828;
  margin-top: 8px;
}

.styles_modalGrid__z9HoQ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 18px;
}

.styles_span2__K9put {
  grid-column: 1 / -1;
}

@media (max-width: 520px) {
  .styles_modalGrid__z9HoQ {
    grid-template-columns: 1fr;
  }

  .styles_span2__K9put {
    grid-column: auto;
  }
}

.styles_modalFooter__AZSlE {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.styles_deleteText__0G2tw {
  font-size: 1.05rem;
  color: #333;
  margin: 0 0 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Impostos/styles.module.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* Layout alinhado ao protótipo definicao/esocial-imposto.txt */\n\n.page {\n  background: #fff;\n  margin: 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  padding: 28px 32px 32px;\n  box-sizing: border-box;\n}\n\n.pageHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n\n.pageTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n  font-size: 26px;\n  font-weight: 700;\n  color: #0d2847;\n  margin: 0;\n}\n\n.pageTitleIcon {\n  font-size: 28px !important;\n  color: #0d2847;\n}\n\n.pageSubtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: #666;\n  font-weight: 400;\n  max-width: 640px;\n}\n\n.btnPrimary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #1e4a7a;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnPrimary:hover {\n  background: #163a62;\n}\n\n.btnPrimary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btnSecondary {\n  padding: 10px 18px;\n  border-radius: 6px;\n  border: 1px solid #cfd8dc;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  color: #333;\n}\n\n.btnSecondary:hover {\n  background: #f5f5f5;\n}\n\n.btnFilter {\n  padding: 10px 18px;\n  border-radius: 6px;\n  border: 1px solid #cfd8dc;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  color: #444;\n  height: 42px;\n}\n\n.btnFilter:hover {\n  background: #f0f2f5;\n}\n\n.filtersPanel {\n  border: 1px solid #e8eef3;\n  border-radius: 10px;\n  padding: 18px 20px;\n  margin-bottom: 22px;\n  background: #fafbfc;\n}\n\n.filtersTitle {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0d2847;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 14px;\n}\n\n.filtersGrid {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr auto;\n  gap: 16px 20px;\n  align-items: end;\n}\n\n@media (max-width: 960px) {\n  .filtersGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .filtersGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.formField label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0d2847;\n  margin-bottom: 6px;\n}\n\n.formField input,\n.formField select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #cfd8dc;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.formField input:focus,\n.formField select:focus {\n  outline: none;\n  border-color: #1e4a7a;\n  box-shadow: 0 0 0 2px rgba(30, 74, 122, 0.15);\n}\n\n.formField input:disabled {\n  background: #f5f5f5;\n  color: #666;\n}\n\n.refRange {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 8px;\n  align-items: center;\n}\n\n.refRange span {\n  font-size: 12px;\n  color: #888;\n  text-align: center;\n}\n\n.empresaSearchWrap {\n  position: relative;\n}\n\n.empresaSugestoes {\n  display: none;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  margin-top: 4px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  max-height: 220px;\n  overflow-y: auto;\n  z-index: 50;\n}\n\n.empresaSugestoesVisible {\n  display: block;\n}\n\n.empresaSugestaoItem {\n  padding: 10px 14px;\n  cursor: pointer;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.empresaSugestaoItem:hover {\n  background: #f5f8fb;\n}\n\n.empresaSugestaoNome {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.empresaSugestaoCnpj {\n  font-size: 12px;\n  color: #888;\n  margin-top: 2px;\n}\n\n.listHint {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 12px;\n}\n\n.tableWrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1100px;\n}\n\n.table thead {\n  background: #f8f9fa;\n}\n\n.table th {\n  padding: 12px 14px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  font-size: 13px;\n  border-bottom: 1px solid #e8e8e8;\n  white-space: nowrap;\n}\n\n.table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n  color: #444;\n}\n\n.num {\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.table th.num,\n.table td.num {\n  text-align: center;\n}\n\n.table tbody tr:hover {\n  background: #fafbfc;\n}\n\n.badgeCprb {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.badgeSim {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.badgeNao {\n  background: #f5f5f5;\n  color: #616161;\n}\n\n.acoesCell {\n  display: flex;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.btnIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background: transparent;\n  color: #1e4a7a;\n}\n\n.btnIcon:hover {\n  background: #eef2f7;\n}\n\n.btnIconDanger {\n  color: #c62828;\n}\n\n.btnIconDanger:hover {\n  background: #ffebee;\n}\n\n.emptyMsg {\n  text-align: center;\n  padding: 32px 16px;\n  color: #888;\n  font-size: 14px;\n}\n\n.loadingMsg {\n  text-align: center;\n  padding: 32px 16px;\n  color: #666;\n  font-size: 14px;\n}\n\n.modalHint {\n  font-size: 12px;\n  color: #888;\n  margin-top: 6px;\n}\n\n.empresaSelecionada {\n  margin-top: 10px;\n  padding: 10px 12px;\n  background: #e3f2fd;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.empresaSelecionada strong {\n  display: block;\n  color: #0d2847;\n}\n\n.empresaSelecionada span {\n  color: #555;\n  font-size: 12px;\n}\n\n.formError {\n  font-size: 12px;\n  color: #c62828;\n  margin-top: 8px;\n}\n\n.modalGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 18px;\n}\n\n.span2 {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 520px) {\n  .modalGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .span2 {\n    grid-column: auto;\n  }\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.deleteText {\n  font-size: 1.05rem;\n  color: #333;\n  margin: 0 0 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `styles_page__6QxgI`,
	"pageHeader": `styles_pageHeader__B6L7O`,
	"pageTitle": `styles_pageTitle__ZSo1b`,
	"pageTitleIcon": `styles_pageTitleIcon__9TKKK`,
	"pageSubtitle": `styles_pageSubtitle__tOToz`,
	"btnPrimary": `styles_btnPrimary__wKjwT`,
	"btnSecondary": `styles_btnSecondary__Uk77F`,
	"btnFilter": `styles_btnFilter__WO0Vb`,
	"filtersPanel": `styles_filtersPanel__Kkjyn`,
	"filtersTitle": `styles_filtersTitle__gHv9X`,
	"filtersGrid": `styles_filtersGrid__Y-wu-`,
	"formField": `styles_formField__qZh8f`,
	"refRange": `styles_refRange__rB5yr`,
	"empresaSearchWrap": `styles_empresaSearchWrap__olTUb`,
	"empresaSugestoes": `styles_empresaSugestoes__XkmOq`,
	"empresaSugestoesVisible": `styles_empresaSugestoesVisible__8eCEY`,
	"empresaSugestaoItem": `styles_empresaSugestaoItem__C3HbU`,
	"empresaSugestaoNome": `styles_empresaSugestaoNome__0V+aR`,
	"empresaSugestaoCnpj": `styles_empresaSugestaoCnpj__uNrPw`,
	"listHint": `styles_listHint__Ys3jC`,
	"tableWrap": `styles_tableWrap__+Nr8J`,
	"table": `styles_table__B59CT`,
	"num": `styles_num__Uvn9X`,
	"badgeCprb": `styles_badgeCprb__n342Z`,
	"badgeSim": `styles_badgeSim__tjrqB`,
	"badgeNao": `styles_badgeNao__CL6XC`,
	"acoesCell": `styles_acoesCell__2WxJA`,
	"btnIcon": `styles_btnIcon__RJJIf`,
	"btnIconDanger": `styles_btnIconDanger__BvCAG`,
	"emptyMsg": `styles_emptyMsg__9vfvw`,
	"loadingMsg": `styles_loadingMsg__uA5Ym`,
	"modalHint": `styles_modalHint__-Ile4`,
	"empresaSelecionada": `styles_empresaSelecionada__7jhrR`,
	"formError": `styles_formError__CNZgY`,
	"modalGrid": `styles_modalGrid__z9HoQ`,
	"span2": `styles_span2__K9put`,
	"modalFooter": `styles_modalFooter__AZSlE`,
	"deleteText": `styles_deleteText__0G2tw`
};
export default ___CSS_LOADER_EXPORT___;
